import * as React from 'react'
import { Mutation, MutationFunction } from 'react-apollo'

import Form, { FormItem } from 'main/components/common/Form'
import { UPDATE_USER_MUTATION, UpdateUser, UpdateUserVariables } from 'main/gql/user'
import { Button, colors, spacing, Text, TextField } from 'main/ui'

interface IProps {
  onRequestClose: () => void
}

export default function PasswordForm(props: IProps) {
  const { onRequestClose } = props

  const [password, setPassword] = React.useState<string>('')
  const [validationHint, setValidationHint] = React.useState<string>('')
  const [error, setError] = React.useState<boolean>(false)

  return (
    <Mutation<UpdateUser, UpdateUserVariables>
      mutation={UPDATE_USER_MUTATION}
      onError={() => setError(true)}
    >
      {(mutate, { loading }) => (
        <Form
          onSubmit={() =>
            handleSubmit(mutate, password, setError, setValidationHint, onRequestClose)
          }
        >
          <FormItem label="Set a password for your account">
            <TextField
              disabled={loading}
              label="Create a password"
              placeholder="Password"
              type="password"
              validationHint={validationHint}
              value={password}
              onChange={setPassword}
              required
            />
          </FormItem>

          {error && (
            <div css={{ marginTop: spacing.majorScale(2) }}>
              <Text css={{ color: colors.text.error }}>
                Something went wrong! Please try again.
              </Text>
            </div>
          )}

          <div css={{ marginTop: spacing.majorScale(6) }}>
            <Button full kind="regular" disabled={loading}>
              Done
            </Button>
          </div>
        </Form>
      )}
    </Mutation>
  )
}

function handleSubmit(
  mutate: MutationFunction<UpdateUser, UpdateUserVariables>,
  password: string,
  setError: React.Dispatch<React.SetStateAction<boolean>>,
  onChangeValidationHint: React.Dispatch<React.SetStateAction<string>>,
  onRequestClose: () => void,
) {
  setError(false)
  onChangeValidationHint('')

  // Closes modal if no password is provided
  if (password.length === 0) {
    return onRequestClose()
  }

  // Mirrors changeset validation in user schema
  if (password.trim().length < 2) {
    return onChangeValidationHint('Please enter a longer password')
  }

  mutate({
    variables: {
      user: { password },
    },
  }).then(() => onRequestClose())
}
